import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import {FeatureFlagsResponse} from 'src/app/models/feature-flag.model';

const SERVICE_NAME = 'mgmt-feature-resources';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  constructor(private fabricService: FabricService) {}

  getTenantFeatures(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_features');
  }

  patchTenantIdFeatures(payload): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'patch_mgmt_tenants_tenantid_features', payload);
  }

  getTenantIdFeatures(tenantId): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_features', {tenantId});
  }

  getTenantIdFeatureFlags(id: string): Observable<FeatureFlagsResponse> {
    return this.fabricService.invokeOperation<FeatureFlagsResponse>(SERVICE_NAME, 'get_mgmt_tenants_id_feature-flags', {id});
  }

  getInstanceFeatureFlags(instanceId: string): Observable<FeatureFlagsResponse> {
    return this.fabricService.invokeOperation<FeatureFlagsResponse>(SERVICE_NAME, 'get_mgmt_instances_id_feature-flags', {id: instanceId});
  }

}
